<template>
  <div>
    <b-card class="mb-4">
      <div v-if="editMode == 0" class="d-flex">
        <div class="ml-auto">
          <b-button variant="primary" @click="EditMode">
            <font-awesome-icon icon="edit" />แก้ไขจำนวนผู้เข้าร่วม
          </b-button>
        </div>
      </div>
      <div v-if="editMode == 1" class="d-flex justify-content-between">
        <div>
          <b-button variant="success" @click="edit">
            <font-awesome-icon icon="save" />บันทึก
          </b-button>
        </div>
        <div>
          <b-button variant="outline-secondary" @click="EditMode">
            <font-awesome-icon icon="times-circle" />ยกเลิก
          </b-button>
        </div>
      </div>
    </b-card>
    <b-card no-body>
      <h6 slot="header" class="mb-0">
        <font-awesome-icon icon="table" />ตารางแสดงข้อมูลผู้เข้าร่วมโครงการ
      </h6>

      <table class="table mb-0">
        <thead>
          <tr>
            <th class="text-center">ผู้เข้าร่วม</th>
            <th class="text-center" width="35%">จำนวนตามแผน (คน)</th>
            <th class="text-center" width="35%">จำนวนตามจริง (คน)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="align-middle text-center">
              <strong>นักศึกษา</strong>
            </td>
            <td class="text-center">
              {{ attendee.student }}
            </td>
            <td class="text-center">
              <div v-if="editMode == 0">
                {{ actualAttendee.student }}
              </div>
              <div v-if="editMode == 1">
                <b-form-input v-model="form.student" :value="actualAttendee.student" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="align-middle text-center">
              <strong>อาจารย์</strong>
            </td>
            <td class="text-center">
              {{ attendee.instructor }}
            </td>
            <td class="text-center">
              <div v-if="editMode == 0">
                {{ actualAttendee.instructor }}
              </div>
              <div v-if="editMode == 1">
                <b-form-input v-model="form.instructor" :value="actualAttendee.instructor" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="align-middle text-center">
              <strong>อื่นๆ</strong>
            </td>
            <td class="text-center">
              {{ attendee.others }}
            </td>
            <td class="text-center">
              <div v-if="editMode == 0">
                {{ actualAttendee.others }}
              </div>
              <div v-if="editMode == 1">
                <b-form-input v-model="form.others" :value="actualAttendee.others" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    attendee: { type: Object, required: true },
    actualAttendee: { type: Object, required: true }
  },
  data () {
    return {
      editMode: 0,
      form: {
        student: this.actualAttendee.student,
        instructor: this.actualAttendee.instructor,
        others: this.actualAttendee.others
      }
    }
  },
  methods: {
    EditMode () {
      this.editMode = !this.editMode
    },
    async edit () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $input: ProjectAttendeeCountInput) { projectActualAttendeeEdit(id: $id, input: $input) { id } }`,
        variables: {
          id: this.$route.params.id,
          input: {
            instructor: this.form.instructor,
            student: this.form.student,
            others: this.form.others
          }
        }
      }).then(() => {
        this.$bvToast.toast('แก้ไขจำนวนผู้เข้าร่วมตามจริงสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
        this.editMode = 0
      })
      this.editMode = 0
      this.$emit('finish')
    }
  }
}
</script>

<style lang="scss" scoped>
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
th {

  &:first-child {
    background-color: #e7e7e7;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
